import React from "react";
import { Paper, Box, Avatar, Typography, Grid, Divider } from "@mui/material";
import { API_BASE_URL } from "../../utils/api";

const ProfileCard = ({ user }) => {
  const avatarSrc = user?.PhotoGraphicFileName
    ? `${API_BASE_URL}/memberimages/${encodeURIComponent(user.PhotoGraphicFileName)}`
    : "https://via.placeholder.com/60";

  const fullName = `${user?.Name || user?.FirstName || ""} ${user?.Lastname || user?.LastName || ""}`.trim();
  const address = user?.Address || user?.FullAddress || "N/A";
  const joinedDate = user?.Joined || user?.JoinDate;

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header with Avatar */}
      <Box
        sx={{
          backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.3), rgba(0,0,0,0.1)), url("https://lexington.myhoa.club/api/logo/Our_Club_1920x400.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          py: 4,
          px: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Avatar
          alt="Owner Avatar"
          src={avatarSrc}
          sx={{ width: 72, height: 72, border: "3px solid white" }}
        />
        <Box>
          <Typography
            variant="h6"
            fontWeight="bold"
            color="common.white"
            sx={{ textShadow: "0 1px 3px rgba(0,0,0,0.5)" }}
          >
            {user ? fullName || "Unnamed Owner" : "Loading..."}
          </Typography>
          <Typography variant="body2" color="grey.100">
            Homeowner
          </Typography>
        </Box>
      </Box>

      {/* Divider */}
      <Divider />

      {/* Detail Grid */}
      <Box sx={{ px: 3, py: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="bold" gutterBottom>
              📞 Phone Number
            </Typography>
            <Typography variant="body1" gutterBottom>
              {user?.PhoneNumber || "N/A"}
            </Typography>

            <Typography variant="body2" fontWeight="bold" gutterBottom>
              📧 Email
            </Typography>
            <Typography variant="body1">
              {user?.Email || "N/A"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="body2" fontWeight="bold" gutterBottom>
              🏠 Property Address
            </Typography>
            <Typography variant="body1" gutterBottom>
              {address}
            </Typography>

            <Typography variant="body2" fontWeight="bold" gutterBottom>
              🗓 Joined On
            </Typography>
            <Typography variant="body1">
              {joinedDate ? new Date(joinedDate).toLocaleDateString() : "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default ProfileCard;
